<template>
  <div class="container">
    <div class="contents">
      <img src="@/assets/img/apology.png" class="apology-image" />
      <p>ポートフォリオサイト移転しました。</p>
      <p>お手数ですが下記URLから新しいページを移動お願いします。</p>
      <a class="button" href="https://next-ts-portfolio-kappa.vercel.app/">新しいページ</a>
    </div>
  </div>
</template>

<script>
  // 認証関連
  import firebase from 'firebase'

  export default {
    name: 'Welcome',
    head: {
      meta: [
        { name: 'description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
        { property: 'og:title', content: 'トップページ' },
        { property: 'og:description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://example.com' },
        { property: 'og:image', content: 'https://example.com/img/og.png' },
        { name: 'twitter:card', content: 'summary' }
      ]
    },
    data () {
      return {
        // 認証関連
        email: firebase.auth().currentUser.email
      }
    },
    methods: {
      // 認証関連
      signOut: function () {
        firebase.auth().signOut().then(() => {
          this.$router.push('/signin')
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .apology-image {
    display: block;
    margin: 0 auto;
    width: 50%;
  }
  a {
    text-decoration: none;
  }
  .button {
    display: block;
    color: #fff;
    margin: 24px auto;
    padding: 8px;
    width: 240px;
    background:  #42b983;
    border: 1px solid #42b983;
    border-radius: 30px;
    transition: .5s;
  }
  .button:hover {
    color: #42b983;
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue